export const MODAL_SET = 'Dyzio/Modal/MODAL_SET';
export const MODAL_CLEAR = 'Dyzio/Modal/MODAL_CLEAR';
export const MODAL_LOADING = 'Dyzio/Modal/MODAL_LOADING';
export const MODAL_ERROR = 'Dyzio/Modal/MODAL_ERROR';



/** WEBPACK FOOTER **
 ** ./src/constants/modal.js
 **/